import React, { useState } from 'react';
import { Layout, Menu, Avatar, Dropdown, Space } from 'antd';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import {
  HomeOutlined,
  AppstoreOutlined,
  UserOutlined,
  LogoutOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  TeamOutlined,
  ShopOutlined,
  UserSwitchOutlined,
  ApartmentOutlined,
  SafetyCertificateOutlined,
} from '@ant-design/icons';
import { useAuth } from '../../context/AuthContext';
import authService from '../../utils/login/AuthService';
import './index.css';

const { Header, Sider, Content } = Layout;

const AppLayout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout: handleLogout } = useAuth();

  // 菜单配置
  const menuItems = [
    {
      key: '/',
      icon: <HomeOutlined />,
      label: '首页',
    },
    {
      key: '/users',
      icon: <UserOutlined />,
      label: '用户管理',
    },
    {
      key: '/roles',
      icon: <TeamOutlined />,
      label: '角色管理',
    },
    {
      key: '/tenants',
      icon: <ShopOutlined />,
      label: '租户管理',
    },
    {
      key: '/user-roles',
      icon: <UserSwitchOutlined />,
      label: '用户角色',
    },
    {
      key: '/user-tenants',
      icon: <ApartmentOutlined />,
      label: '用户租户',
    },
    {
      key: '/admin-register',
      icon: <AppstoreOutlined />,
      label: '管理端注册',
    },
    {
      key: '/user-system-permissions',
      icon: <SafetyCertificateOutlined />,
      label: '人员系统权限',
    },
  ];

  // 菜单点击
  const handleMenuClick = ({ key }) => {
    navigate(key);
  };

  // 用户下拉菜单
  const userMenuItems = [
    {
      key: 'profile',
      label: '个人中心',
      icon: <UserOutlined />,
    },
    {
      type: 'divider',
    },
    {
      key: 'logout',
      label: '退出登录',
      icon: <LogoutOutlined />,
      danger: true,
    },
  ];

  // 用户菜单点击
  const handleUserMenuClick = async ({ key }) => {
    if (key === 'logout') {
      try {
        await authService.logout();
        handleLogout();
        navigate('/login');
      } catch (error) {
        console.error('登出失败:', error);
        handleLogout();
        navigate('/login');
      }
    } else if (key === 'profile') {
      navigate('/profile');
    }
  };

  return (
    <Layout className="app-layout">
      <Sider trigger={null} collapsible collapsed={collapsed} className="app-sider">
        <div className="logo">
          { 'ZJSSO'}
        </div>
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[location.pathname]}
          items={menuItems}
          onClick={handleMenuClick}
        />
      </Sider>
      <Layout>
        <Header className="app-header">
          <div className="header-left">
            {React.createElement(collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
              className: 'trigger',
              onClick: () => setCollapsed(!collapsed),
            })}
          </div>
          <div className="header-right">
            <Dropdown
              menu={{
                items: userMenuItems,
                onClick: handleUserMenuClick,
              }}
              placement="bottomRight"
            >
              <Space className="user-info" style={{ cursor: 'pointer' }}>
                <Avatar icon={<UserOutlined />} />
                <span>{user?.username || user?.name || '用户'}</span>
              </Space>
            </Dropdown>
          </div>
        </Header>
        <Content className="app-content">
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default AppLayout;

